import LoadingIndicator from '@wix/da-ds/pkg/LoadingIndicator';
import ErrorBoundary from '@wix/da-react-context/pkg/ErrorBoundary';
import React, { Suspense, lazy } from 'react';
import retry from '../utils/webpack/chunkRetry';
import { Props } from './EmoteSelectorNg';

const LoadableRedux = lazy(() =>
  retry(
    () =>
      import(
        /* webpackChunkName: "emote_selector" */
        './redux/ModuleLoadable'
      )
  )
);

const LoadableSelector = lazy(() =>
  retry(
    () =>
      import(
        /* webpackChunkName: "emote_selector" */
        './EmoteSelectorNg'
      )
  )
);

const EmoteSelectorNgLoadable: React.FC<Props> = props => {
  return (
    <ErrorBoundary debugComponent="EmoteSelectorNgLoadable">
      <Suspense fallback={<LoadingIndicator view={'llama'} />}>
        <LoadableRedux {...props} />
        <LoadableSelector {...props} />
      </Suspense>
    </ErrorBoundary>
  );
};
EmoteSelectorNgLoadable.displayName = 'EmoteSelectorNgLoadable';

export default EmoteSelectorNgLoadable;
